<template>
    <fragment>
        <el-button type="text" @click="obnCancelBtn">{{title}}</el-button>
        <div>
            <contractManagementCancelDialog :visible.sync="visible" :row="row" @ok="ok" />
        </div>
    </fragment>
</template>

<script>
export default {
    components: {
        contractManagementCancelDialog: () => import('./contractManagementCancelDialog'),
    },
    props: {
        row: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            visible: false,
            title:'',
        };
    },
    mounted() {
        if (this.row.isfinish === 0){
          this.title = '放弃详情'
        }else{
          this.title = '放弃'
        }
    },
    methods: {
        ok() {
            this.$emit('ok')
        },
        async obnCancelBtn() {
            this.visible = true
        }
    }
};
</script>
